module.exports = __webpack_public_path__ + "static/img/gggggg_06.dc62aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_06.png
// module id = OIEG
// module chunks = 1